import React, { useEffect, useRef, useState } from "react";
import { Container, Grid2 } from "@mui/material";
// import vendorLogo from "../assets/images/vendor-logo.png";
import bannerLeftImage from "../assets/images/banner-left-image.png";

import map from "../assets/images/map-pin.png";
import { useParams } from "react-router-dom";
import DishCard from "../components/common/DishCard";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";
import vendorService from "../services/vendorService";
import Breadcrumbs from "../components/common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import DishCardSkeleton from "../components/common/DishCardSkeleton";
import Skeleton from "react-loading-skeleton";
import { handleErrors } from "../utils/error-handler";
import StickyStripe from "../components/common/StickyStripe";
import { ErrorHandlingDesign } from "../components/common/errorHandlingDesign";
const VendorCatalog = () => {
  // const [selectedVariantIndex, setSelectedVariantIndex] = useState({});
  // const location = useLocation();
  const navbarRef = useRef(null);
  const { vendorUrl } = useParams();
  const id = vendorUrl?.split("-").pop();
  const [loading, setLoading] = useState(true);
  // const {  id } = location.state || {};
  const navigate = useNavigate();
  const [vendorDetails, setVendorDetails] = useState(null);
  const [vendorProducts, setVendorProducts] = useState([]);
  const [error, setError] = useState(null);
  const [showProductBadge, setshowProductBadge] = useState(true);

  useEffect(() => {
    const fetchVendorDetails = async () => {
      if (!id) {
        console.error("Missing params:", { id });
        return;
      }
      try {
        const data = await vendorService.getVendorDetails(id);
        setVendorDetails(data);
        setshowProductBadge(
          data?.vendorName === "Ambica" || data?.vendorName === "Sha Misrimal"
            ? false
            : true
        );

        let productImages = [];
        data?.vendorProducts?.forEach((vendorProduct, index) =>
          vendorProduct.products.forEach((product, indexx) => {
            productImages = [...productImages, product.productImage];
            return productImages;
          })
        );
        const allImages = new Set(productImages);
        setVendorProducts(Array.from(allImages));
        setError(null);
      } catch (error) {
        setError("Failed to load data.");
        handleErrors(error);
      } finally {
        setLoading(false);
      }
    };
    fetchVendorDetails();
  }, [id]);

  const groupedProducts = {};

  vendorDetails?.vendorProducts?.forEach((category) => {
    category.products.forEach((product) => {
      const name = product.productName;
      if (!groupedProducts[name]) {
        groupedProducts[name] = [];
      }
      groupedProducts[name].push(product);
    });
  });
  const FinalmenuItems =
    vendorDetails?.vendorProducts
      ?.filter((cat) => Array.isArray(cat.products) && cat.products.length > 0)
      .map((cat) => ({
        id: cat.categoryName.replace(/\s+/g, "_").toLowerCase(),
        label: `${cat.categoryName} (${cat.categoryCount})`,
      })) || [];

  const [activeId, setActiveId] = useState(FinalmenuItems?.[0]?.id || "");
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin: "-100px 0px -80% 0px", threshold: 0.1 }
    );

    const sections = document.querySelectorAll(".section-content-gap[id]");

    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, [vendorDetails]);

  return (
    <>
      {error ? (
        <ErrorHandlingDesign errorMessage={error} />
      ) : (
        <>
          <section className="vendor-catalog-banner inner-baner">
            <Container>
              <div className="banner-content">
                <div className="catalog-banner-content">
                  <div className="vendor-info-wrapper">
                    <div className="breadcrumb">
                      <Breadcrumbs />
                    </div>
                    <div className="back-arrow">
                      <div
                        className="back-arrow text-white"
                        onClick={() => navigate(-1)}
                        style={{ cursor: "pointer" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M10.0164 2.86402C10.5046 2.41035 11.2681 2.43834 11.7218 2.92652C12.1754 3.41471 12.1475 4.17823 11.6593 4.63189L5.9091 9.97545C5.56441 10.2958 5.27721 10.5634 5.03763 10.795L21.7309 10.795C22.3974 10.795 22.9376 11.3353 22.9376 12.0017C22.9376 12.6681 22.3974 13.2084 21.7309 13.2084L4.96299 13.2084C5.21692 13.4563 5.52784 13.7462 5.90908 14.1005L11.5886 19.3785C12.0768 19.8322 12.1048 20.5957 11.6511 21.0839C11.1974 21.5721 10.4339 21.6 9.94575 21.1464L4.20777 15.814C3.51539 15.1707 2.90681 14.6052 2.48249 14.0857C2.02422 13.5246 1.65356 12.8684 1.65356 12.0379C1.65357 11.2075 2.02424 10.5513 2.48251 9.99021C2.90682 9.47068 3.51538 8.90523 4.20774 8.26193L10.0164 2.86402Z"
                            fill="#02060C"
                            fillOpacity="0.75"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="vendor-info">
                      <div className="vendor-logo">
                        <img src={vendorDetails?.imageURL} alt="" />
                      </div>
                      <div className="title">
                        <h1 className="text-white-highest-emphasis">
                          {loading ? (
                            <Skeleton width={200} />
                          ) : (
                            vendorDetails?.vendorName
                          )}
                        </h1>
                        <p className="text-dark-high-emphasis">
                          {/* Quick-Assemble Packaging, Stackable & Flatpack{" "} */}
                          {loading ? (
                            <Skeleton width={300} />
                          ) : (
                            vendorDetails?.shortDescription
                          )}
                        </p>
                        <div className="vendor-badge-wrap">
                          {loading
                            ? Array.from({ length: 1 }).map((_, index) => (
                                <div className="badge-item11" key={index}>
                                  <Skeleton width={60} height={12} />
                                </div>
                              ))
                            : vendorDetails?.vTags
                                ?.split(",")
                                .map((tag, index) => (
                                  <div className="badge-item" key={index}>
                                    <span>{tag.trim()}</span>
                                  </div>
                                ))}
                        </div>

                        <ul>
                          <li>
                            <img src={map} alt="" />
                            <span>
                              {" "}
                              {loading ? (
                                <Skeleton width={100} />
                              ) : (
                                vendorDetails?.vLocation
                              )}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="vendor-banner-right-image">
                    <img
                      src={bannerLeftImage}
                      alt=""
                      className="desktop-banner home-banner"
                    />
                  </div>
                  {/* {vendorProducts && (
                <div className="verticle-slider-banner">
                  <div className="verticle-slider-item">
                    <Swiper
                      key={vendorProducts.length}
                      direction="vertical"
                      slidesPerView={"auto"}
                      spaceBetween={6}
                      loop
                      speed={5000}
                      autoplay={{
                        delay: 0,
                        disableOnInteraction: false,
                        reverseDirection: false,
                      }}
                      modules={[Autoplay]}
                    >
                      {vendorProducts?.map((productImage, index) => (
                        <SwiperSlide key={index}>
                          <div className="product-image">
                            <img src={productImage} alt="" />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                  <div className="verticle-slider-item">
                    <Swiper
                      key={vendorProducts.length}
                      direction="vertical"
                      slidesPerView={"auto"}
                      spaceBetween={6}
                      loop
                      speed={5000}
                      autoplay={{
                        delay: 0,
                        disableOnInteraction: false,
                        reverseDirection: true,
                      }}
                      modules={[Autoplay]}
                    >
                      {vendorProducts?.map((productImage, index) => (
                        <SwiperSlide key={index}>
                          <div className="product-image">
                            <img src={productImage} alt="" />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                  <div className="verticle-slider-item">
                    <Swiper
                      key={vendorProducts.length}
                      direction="vertical"
                      slidesPerView={"auto"}
                      spaceBetween={6}
                      loop
                      speed={5000}
                      autoplay={{
                        delay: 0,
                        disableOnInteraction: false,
                        reverseDirection: false,
                      }}
                      modules={[Autoplay]}
                    >
                      {vendorProducts?.map((productImage, index) => (
                        <SwiperSlide key={index}>
                          <div className="product-image">
                            <img src={productImage} alt="" />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              )} */}
                </div>
              </div>
            </Container>
          </section>
          <section className="packaging-options">
            <Container>
              <Grid2 container spacing={2}>
                <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                  <div className="section-title">
                    <h2>Available packaging options</h2>
                  </div>
                </Grid2>
              </Grid2>
              {loading ? (
                <Grid2 container spacing={2} className="section-content-gap">
                  {Array.from({ length: 4 }).map((_, idx) => (
                    <Grid2 key={idx} size={{ lg: 3, md: 4, sm: 6, xs: 6 }}>
                      <DishCardSkeleton />
                    </Grid2>
                  ))}
                </Grid2>
              ) : (
                <div className="sticky-material-menu">
                  <section className="dish-material-menu vendor-sticky-menu">
                    <Grid2
                      container
                      spacing={1}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid2 size={12}>
                        <div className="material-card-menu packaging-detail-sticky-menu">
                          <ul className="packaging-info-list packaging-material">
                            {FinalmenuItems.map((item, index) => (
                              <StickyStripe
                                isShowIcon={false}
                                navMenu={item}
                                key={index}
                                stickyMenuItems={FinalmenuItems}
                                navbarRef={navbarRef}
                                defaultActiveState={FinalmenuItems[0]?.id}
                              />
                            ))}
                          </ul>
                        </div>
                      </Grid2>
                    </Grid2>
                  </section>
                  {vendorDetails?.vendorProducts
                    ?.filter((category) => category.products.length > 0)
                    .map((category, index) => {
                      // Group products by productName and productUrl
                      const grouped = {};
                      category.products.forEach((product) => {
                        const key = `${product.productName}-${product.productUrl}`;
                        if (!grouped[key]) grouped[key] = [];
                        grouped[key].push(product);
                      });

                      return (
                        <section
                          className="vendor-product-listing dish-wrapper"
                          key={index}
                          id={category.categoryName
                            .replace(/\s+/g, "_")
                            .toLowerCase()}
                        >
                          <Grid2 container spacing={2}>
                            <Grid2 size={12}>
                              <div className="packaging-subtitle">
                                <h3>{category.categoryName}</h3>
                              </div>
                            </Grid2>
                            {Object.entries(grouped).map(([key, group], i) => {
                              const base = group[0];
                              const priceList = group
                                .filter(
                                  (item) =>
                                    item.productDimesion &&
                                    item.productDimesion.trim() !== ""
                                )
                                .map((item, idx) => ({
                                  id: `${item.productId}-${idx}`,
                                  price: item.price || "0.00",
                                  productDimesion: item.productDimesion,
                                  moq: item.moq || "N/A",
                                }));

                              return (
                                <Grid2
                                  key={key}
                                  size={{ lg: 3, md: 4, sm: 4, xs: 6 }}
                                >
                                  <DishCard
                                    showBadge={showProductBadge}
                                    priceList={priceList}
                                    title={base.productName}
                                    description={base.shortDescription}
                                    price={parseFloat(base.price)}
                                    image={base.productMainImage}
                                    vTags={vendorDetails?.vTags}
                                    productData={base}
                                    link={`enquiry?v=${vendorDetails?.vendorUrl}`}
                                    state={{
                                      vendorName: vendorDetails.vendorName,
                                    }}
                                  />
                                </Grid2>
                              );
                            })}
                          </Grid2>
                        </section>
                      );
                    })}
                </div>
              )}
              {/* <div className="nav-items">
            <section className="new-ul-nav">
              <Grid2
                container
                spacing={1}
                justifyContent="center"
                alignItems="center"
              >
                <Grid2 size={12}>
                  <div className="material-card-menu">
                    <ul className="packaging-info-list">
                      {loading
                        ? Array.from({ length: 4 }).map((_, index) => (
                            <li key={index}>
                              <Skeleton
                                width={160}
                                height={40}
                                borderRadius={20}
                              />
                            </li>
                          ))
                        : FinalmenuItems.map((item, index) => (
                            <StickyStripe
                              isShowIcon={false}
                              navMenu={item}
                              key={index}
                              stickyMenuItems={FinalmenuItems}
                              navbarRef={navbarRef}
                              defaultActiveState={FinalmenuItems[0]?.id}
                            />
                          ))}
                    </ul>
                  </div>
                </Grid2>
              </Grid2>
            </section>
          </div> */}

              {/* {loading ? (
            <Grid2 container spacing={2} className="section-content-gap">
              {Array.from({ length: 4 }).map((_, idx) => (
                <Grid2 key={idx} size={{ lg: 3, md: 4, sm: 6, xs: 6 }}>
                  <DishCardSkeleton />
                </Grid2>
              ))}
            </Grid2>
          ) : (
            vendorDetails?.vendorProducts
              ?.filter((category) => category.products.length > 0)
              .map((category, index) => {
                const grouped = {};
                category.products.forEach((product) => {
                  const key = `${product.productName}-${product.productUrl}`;
                  if (!grouped[key]) grouped[key] = [];
                  grouped[key].push(product);
                });

                return (
                  <Grid2
                    container
                    spacing={2}
                    className="section-content-gap"
                    key={index}
                    id={category.categoryName
                      .replace(/\s+/g, "_")
                      .toLowerCase()}
                  >
                    <Grid2 size={12}>
                      <div className="packaging-subtitle">
                        <h3>{category.categoryName}</h3>
                      </div>
                    </Grid2>

                    {Object.entries(grouped).map(([key, group], i) => {
                      const base = group[0];
                      const priceList = group
                        .filter(
                          (item) =>
                            item.productDimesion &&
                            item.productDimesion.trim() !== ""
                        )
                        .map((item, idx) => ({
                          id: `${item.productId}-${idx}`,
                          price: item.price || "0.00",
                          productDimesion: item.productDimesion,
                          moq: item.moq || "N/A",
                        }));

                      return (
                        <Grid2 key={key} size={{ lg: 3, md: 4, sm: 6, xs: 6 }}>
                          <DishCard
                            priceList={priceList}
                            title={base.productName}
                            description={base.shortDescription}
                            price={parseFloat(base.price)}
                            image={base.productMainImage}
                            productData={base}
                            link={`enquiry?v=${vendorDetails?.vendorUrl}`}
                            state={{
                              vendorName: vendorDetails.vendorName,
                            }}
                          />
                        </Grid2>
                      );
                    })}
                  </Grid2>
                );
              })
          )} */}
            </Container>
          </section>
        </>
      )}
    </>
  );
};

export default VendorCatalog;
